import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/global-error.tsx");
